import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { changeImpactType } from '../lib/schema.js';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';
import { selectCurrentOrganizationId } from './auth.js';
import { selectEntities } from './entities.js';

const RETRIEVE_CHANGE_IMPACT_TYPES_REQUEST =
  'changesync/projects/RETRIEVE_CHANGE_IMPACT_TYPES_REQUEST';
const RETRIEVE_CHANGE_IMPACT_TYPES_SUCCESS =
  'changesync/projects/RETRIEVE_CHANGE_IMPACT_TYPES_SUCCESS';
const RETRIEVE_CHANGE_IMPACT_TYPES_FAILURE =
  'changesync/projects/RETRIEVE_CHANGE_IMPACT_TYPES_FAILURE';

const UPDATE_CHANGE_IMPACT_TYPES_REQUEST =
  'changesync/projects/UPDATE_CHANGE_IMPACT_TYPES_REQUEST';
const UPDATE_CHANGE_IMPACT_TYPES_SUCCESS =
  'changesync/projects/UPDATE_CHANGE_IMPACT_TYPES_SUCCESS';
const UPDATE_CHANGE_IMPACT_TYPES_FAILURE =
  'changesync/projects/UPDATE_CHANGE_IMPACT_TYPES_FAILURE';

const initialState = {
  changeImpactTypesIds: [],
  retrieveChangeImpactTypes: {
    pending: false,
    success: false,
    error: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_CHANGE_IMPACT_TYPES_REQUEST:
      return {
        ...state,
        retrieveChangeImpactTypes: {
          ...state.retrieveChangeImpactTypes,
          pending: true,
          success: false,
          error: null,
        },
      };
    case RETRIEVE_CHANGE_IMPACT_TYPES_SUCCESS:
      return {
        ...state,
        changeImpactTypesIds: action.payload.result,
        retrieveChangeImpactTypes: {
          ...state.retrieveChangeImpactTypes,
          pending: false,
          success: true,
        },
      };
    case RETRIEVE_CHANGE_IMPACT_TYPES_FAILURE:
      return {
        ...state,
        retrieveChangeImpactTypes: {
          ...state.retrieveChangeImpactTypes,
          pending: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};

export const retrieveChangeImpactTypes = () => (dispatch, getState) => {
  const organizationId = selectCurrentOrganizationId(getState());

  return dispatch({
    [CALL_API]: {
      types: [
        RETRIEVE_CHANGE_IMPACT_TYPES_REQUEST,
        RETRIEVE_CHANGE_IMPACT_TYPES_SUCCESS,
        RETRIEVE_CHANGE_IMPACT_TYPES_FAILURE,
      ],
      endpoint: `organizations/${organizationId}/change_impact_types`,
      method: HTTP_METHODS.GET,
      schema: [changeImpactType],
    },
  });
};

export const updateChangeImpactTypes =
  (changeImpactTypes) => (dispatch, getState) => {
    const organizationId = selectCurrentOrganizationId(getState());

    const endpoint = `organizations/${organizationId}/change_impact_types/bulk_update`;
    return dispatch({
      [CALL_API]: {
        types: [
          UPDATE_CHANGE_IMPACT_TYPES_REQUEST,
          UPDATE_CHANGE_IMPACT_TYPES_SUCCESS,
          UPDATE_CHANGE_IMPACT_TYPES_FAILURE,
        ],
        endpoint,
        method: HTTP_METHODS.PUT,
        body: changeImpactTypes,
      },
    });
  };

export const selectRetrieveChangeImpactTypesState = createSelector(
  (state) => state.changeImpactTypes,
  (changeImpactTypes) => changeImpactTypes.retrieveChangeImpactTypes
);

const selectChangeImpactTypesIds = (state) =>
  state.changeImpactTypes.changeImpactTypesIds;

export const selectChangeImpactTypes = createSelector(
  selectChangeImpactTypesIds,
  selectEntities,
  (projectStatusesIds, entities) =>
    denormalize(projectStatusesIds, [changeImpactType], entities).filter(
      (projectStatus) => !projectStatus.archived
    )
);

export const selectChangeImpactTypesWithArchived = createSelector(
  selectChangeImpactTypesIds,
  selectEntities,
  (projectStatusesIds, entities) =>
    denormalize(projectStatusesIds, [changeImpactType], entities)
);
